module.exports = __webpack_public_path__ + "static/media/3.9fec124b.png";